import React, { useEffect, useState } from "react";
import {
  INavigator,
  MenuLateral,
} from "../../../../Components/MenuLateral/Index";
import { Panel } from "../../../../Components/Panel";
import { Container, Img } from "./styles";
import LogoSinsoft from "../../../../Assets/Sinsoft_Logo.png";
import { useCartorio } from "../../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { Header } from "../../../../Components/Header";
import { TablePanel } from "../../../../Components/TablePanel";
import { Alert } from "../../../../Components/Error/Alert";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { getEnvironmentData } from "worker_threads";
import api from "../../../../Services/api";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";

export interface ICartorios {
  ID: number;
  STATUS: string;
  NOME: string;
  CPF_CNPJ: string;
  PREFEITURA_ID: number;
  CARTORIO_ID: number;
  REJEITADO?:boolean;
}

export function Cartorios() {
  const { prefeituraIsLogged, prefeitura,checarTokenPrefeitura } = usePrefeitura();
  const{checarTokenFuncionarioPrefeitura} = useFuncionarioPrefeitura();
  const{funcionarioPrefeituraIsLogged} = useFuncionarioPrefeitura();
  const { cartorio, cartorioIsLogged } = useCartorio();
  const [cartorios, setCartorios] = useState({} as ICartorios[]);
  const [index, setIndex] = useState(1 as 1 | 2);
  const [error, setError] = useState({ message: "", title: "" });
  const [loading, setLoading] = useState(false);
  const [abas, setAbas] = useState([
    {
      title: "ATIVOS",
      index: 1,
      execute: () => {
        setIndex(1);
        console.log("ATIVOS");
      },
      data: {},
    },
    {
      title: "PENDENTES",
      index: 2,
      execute: () => {
        setIndex(2);
      },
      data: {},
    },
  ]);

  function defineCartorios() {
    if(cartorios)
    if(cartorios.length > 0)
    if(index == 1){
      return cartorios.filter((item) => {
        if (item.STATUS != null)
          return item.STATUS.trim().toUpperCase() == "A";
      });
    }else{
      return cartorios.filter((item) => {
        if (item.STATUS != null)
          return item.STATUS.trim().toUpperCase() == "P";
      });
    }
    
  }

  async function getData(){
    try {
      setLoading(true);
      if(prefeituraIsLogged){
        await checarTokenPrefeitura();
      }else{
       await checarTokenFuncionarioPrefeitura();
      }
      
      const{data} = await api.get(`/ligacao/by_prefeitura/${prefeitura.ID}`);
      setCartorios(data);
    } catch (error) {
      setError({ message: "Não foi possível carregar os cartórios!", title: "Ops" })
    }finally{
      setLoading(false);
    }

  }
  useEffect(() => {
    if(prefeitura.ID){
      getData()

    }
  },[prefeitura.ID])

  return (
    <>
      <MenuLateral
        titulo={prefeituraIsLogged || funcionarioPrefeituraIsLogged ? prefeitura.NOME : cartorio.NOME}
      />
      <Panel
        children={
          <>
            <Header type={"CARTÓRIOS"} />
            <TablePanel
              abas={abas}
              index={index}
              loading={loading}
              conteudoTabelaCartorios={defineCartorios()}
              tableHeader={["CÓDIGO", "NOME", "CPF | CNPJ"]}
            />
          </>
        }
      />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
      <ModalLoader loading={loading} />
    </>
  );
}
